import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatChipsModule } from '@angular/material/chips';
import { NgModule } from '@angular/core';
import { NavModule } from 'app/modules/nav/nav.module';
import { AddToQueueDropdownModule } from 'app/add-to-queue-dropdown/add-to-queue-dropdown.module';
import { BorrowerSearchInputModule } from 'app/borrower-search-input/borrower-search-input.module';
import { CadenceModule } from 'app/cadence/cadence.module';
import { DirectDialModule } from 'app/direct-dial/direct-dial.module';
import { GlobalHeaderComponent } from './global-header.component';
import { RemindersTodayModule } from 'app/reminders-today/reminders-today.module';
import { UserAvatarModule } from 'app/user-avatar/user-avatar.module';
import { UserMenuModule } from 'app/user-menu/user-menu.module';
import { MatBadgeModule } from '@angular/material/badge';

@NgModule({
  declarations: [
    GlobalHeaderComponent
  ],
  imports: [
    BorrowerSearchInputModule,
    CadenceModule,
    CommonModule,
    DirectDialModule,
    MatBadgeModule,
    MatButtonModule,
    MatChipsModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    NavModule,
    RemindersTodayModule,
    UserAvatarModule,
    AddToQueueDropdownModule,
    UserMenuModule,
  ],
  exports: [
    GlobalHeaderComponent
  ]
})
export class GlobalHeaderModule { }
